import Flex from '@blocks/Flex'
import Info from '@blocks/Info'
import React from 'react'
import { ReactComponent as StarIcon } from '@icons/star.svg'
import { ReactComponent as CrownIcon } from '@icons/crown.svg'
import { useSalonContext } from '@customer/components/pages/Salon/context'

export default function SalonFinishedStatus() {
    const { salon } = useSalonContext()
    
    return (
        <Flex gap="10px">
            <Info label="Results" icon={<StarIcon />} />
            {salon.state.best_author && <Info label="Best Author" icon={<CrownIcon />} />}
        </Flex>
    )
}